












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ripple from "./ripple.vue";
import tooltip from "./tooltip.vue";
import popupmenu, {PopupMenuItem} from "./popupMenu.vue";

@Component({
    components: {
        ripple,
        tooltip,
        popupmenu
    }
})

export default class IconButton extends Vue {

    @Prop({}) icon:string;
    @Prop({}) hint:string;
    @Prop({}) popupMenuContent : any;
    @Prop({}) popupDisplaced : boolean;
    @Prop({}) onButtonClick: Function;
    @Prop({}) flavor: string;
    @Prop({}) light: boolean;
    @Prop({}) white: boolean;
    @Prop({}) toggledOn: boolean;
    @Prop({}) popupNoMax: boolean;
    @Prop({}) circle: boolean;
    @Prop({}) small: boolean;
    @Prop({}) tooltipInivisible: boolean;
    @Prop({}) active: boolean;

    popupContent = null;
    isMenuActive = false;
    isTooltipInvisible = false;
    buttonToggle = this.toggledOn || false;

    mounted(){
        this.assignContent();
    }

    assignContent(){
        this.popupContent = this.popupMenuContent;
    }

    activateButtonCallback(event) {
        event.preventDefault();
        this.isMenuActive = !this.isMenuActive;
        if(this.popupContent){
            this.popupOpen();
        }
        this.$emit('clicked', this.onButtonClick);
    }

    popupOpen(){
        if(this.popupContent) this.isTooltipInvisible = true;
        this.buttonToggle = true;
    }
    popupClosed(){
        this.isTooltipInvisible = false;
        this.buttonToggle = false;
    }

    @Watch('popupMenuContent')
    changeContent(to, from){
        this.assignContent();
    }
    @Watch('toggledOn')
    changeToggle(to, from){
        this.buttonToggle = this.toggledOn;
    }
}

